export function getView(person) {
  return (person.birth_date && person.gender) || person.is_lead
}
